<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';

const model = defineModel<boolean>({
  default: false,
});

function handleCloseClick(): void {
  model.value = false;
}

function handleKeydown(event: KeyboardEvent): void {
  if (event.code === 'Escape') {
    handleCloseClick();
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown);
});
</script>

<template>
  <v-menu
    :class="$style.newAirRoadPopoverVMenu"
    data-testid="newAirRoadPopoverVMenu"
    :model-value="model"
  >
    <v-card width="300">
      <div class="d-flex">
        <div class="w-100 p-4 pb-0"><slot name="header"></slot></div>
        <div>
          <KBtn
            :class="$style.closeBtn"
            variant="text"
            icon="mdi-close"
            @click="handleCloseClick"
          />
        </div>
      </div>
      <div class="p-4">
        <slot></slot>
      </div>
    </v-card>
  </v-menu>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.newAirRoadPopoverVMenu {
}
</style>
